'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _ = _interopDefault(require('lodash/core'));

var React = _interopDefault(require('react'));

var ReactDOM = _interopDefault(require('react-dom'));

var PropTypes = _interopDefault(require('prop-types'));

var classNames = _interopDefault(require('classnames'));

var ResizeSensor = _interopDefault(require('css-element-queries/src/ResizeSensor'));

var WaveCharts = _interopDefault(require('wave-charts'));

var styles = {
  "waveChart": "_wave-chart_o6z9d_1",
  "loading": "_loading_o6z9d_6"
};
var DEFAULT_PADDING = 8;
var ID_PREFIX = "chart_";
var propTypes = {
  // module name of chart type to render
  chartModule: PropTypes.string.isRequired,
  // chart configuration object
  config: PropTypes.object.isRequired,
  // data rows
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  // rows metadata
  rowsMetadata: PropTypes.arrayOf(PropTypes.object).isRequired,
  // render animation duration in milliseconds
  duration: PropTypes.number,
  // chart's selection, array of data rows to show as selected state
  selection: PropTypes.arrayOf(PropTypes.object),
  // chart's annotations
  annotations: PropTypes.arrayOf(PropTypes.object),
  // whether to enable render on demand(only render when chart div is visible in viewport)
  renderOnDemand: PropTypes.bool,
  // width of the chart in pixels
  width: PropTypes.number,
  // height of the chart in pixels
  height: PropTypes.number,
  // - durations {Object} various animation durations
  // 	default (default 800): duration when animating from one set of values to another
  // 	select (default 400): duration when selecting a value on a chart
  // 	scroll (default 400): duration when automatically scrolling back to the top
  // 	firstRender (default 400): duration when the chart is first rendered
  // 	resize (default 400): duration when resizing the chart
  // 	resizeDebounce: (default 100): debounce duration for resize
  // 	If you pass default, the following durations will be computed as default/2: select, scroll, firstRender, resize, resizeDebounce
  // 	(for instance, just pass default:0 to remove *all* durations, or pass default:800 to get all the default durations)
  // 	But you could also specify individual durations if you wanted to...
  durations: PropTypes.object,
  // padding around chart
  padding: PropTypes.number,
  // callback when chart is rendered or skipped render(when initially out of viewport)
  onAfterRender: PropTypes.func,
  // callback when user made a selection on chart which triggers selection change
  onSelectionChange: PropTypes.func,
  // callback when sorting is performed
  onSort: PropTypes.func,
  // callback when clicking on chart
  onClickChart: PropTypes.func,
  // callback when clicking on legend
  onClickLegend: PropTypes.func,
  // callback when mouse enter a hotspot on chart
  onEnterChartHotSpot: PropTypes.func,
  // callback when mouse enter a hotspot on legend
  onEnterLegendHotSpot: PropTypes.func,
  // callback when mouse leave a hotspot on chart
  onLeaveChartHotSpot: PropTypes.func,
  // callback when mouse leave a hotspot on legend
  onLeaveLegendHotSpot: PropTypes.func,
  // callback when perf stats are collect for a render
  onPerfReady: PropTypes.func,
  // callback when an error occured
  onError: PropTypes.func,
  // will be invoked once mounted to pass through the underlying WaveCharts chart instance
  setChartInstance: PropTypes.func,
  // allways rerendering even if the chart config, rows, size, ... have not changed
  force: PropTypes.bool,
  // re-render on resize. Default: true if width && height are not provided
  autoResize: PropTypes.bool,
  // extra class names to add to the root div
  className: PropTypes.string,
  // component to display while chart is rendering
  spinner: PropTypes.element
};
/*
	WaveCharts chart as a React component.

	Uses css-element-queries to dynamically resize the chart to the width / height
	of its container, if width / height are not specified.

	@author alice.chen, ppominville
*/

var WaveChart$1 = function (superclass) {
  function WaveChart(props) {
    superclass.call(this, props);
    this._onResize = this._onResize.bind(this); // the current size of the chart

    this._currentSize = null; // a reference to the chart component

    this._chartRef;
    this.state = {
      isRendering: true
    };
  }

  if (superclass) WaveChart.__proto__ = superclass;
  WaveChart.prototype = Object.create(superclass && superclass.prototype);
  WaveChart.prototype.constructor = WaveChart;

  WaveChart.prototype.componentWillMount = function componentWillMount() {
    // generate a unique name for the chart which we will append to the DOM, allowing us to get the chart instance in
    // tests to simulate interactions
    return this._chartName = _.uniqueId(ID_PREFIX);
  };

  WaveChart.prototype.componentDidMount = function componentDidMount() {
    var size = this.getSize();
    this._chart = WaveCharts.chart({
      name: this._chartName,
      padding: this.props.padding != null ? this.props.padding : DEFAULT_PADDING,
      durations: this.props.durations,
      size: size,
      renderOnDemand: this.props.renderOnDemand != null ? this.props.renderOnDemand : true,
      rendererConfig: {
        el: ReactDOM.findDOMNode(this._chartRef),
        wheelPropagation: false
      }
    });

    var ref = this._chart.getEvents();

    var RENDER_END = ref.RENDER_END;
    var RENDER_SKIPPED = ref.RENDER_SKIPPED;
    var MOUSE_CLICK = ref.MOUSE_CLICK;
    var LEGEND_MOUSE_CLICK = ref.LEGEND_MOUSE_CLICK;
    var MOUSE_ENTER_HOTSPOT = ref.MOUSE_ENTER_HOTSPOT;
    var LEGEND_MOUSE_ENTER_HOTSPOT = ref.LEGEND_MOUSE_ENTER_HOTSPOT;
    var MOUSE_LEAVE_HOTSPOT = ref.MOUSE_LEAVE_HOTSPOT;
    var LEGEND_MOUSE_LEAVE_HOTSPOT = ref.LEGEND_MOUSE_LEAVE_HOTSPOT;
    var SELECTION_CHANGED = ref.SELECTION_CHANGED;
    var SORT = ref.SORT;
    var ERROR = ref.ERROR; // note: charts outside the viewport will fire a renderSkipped event instead of renderEnd.

    this._chart.on(RENDER_END, this._onAfterRender.bind(this));

    this._chart.on(RENDER_SKIPPED, this._onAfterRender.bind(this));

    this._chart.on(MOUSE_CLICK, this._onClickChart.bind(this));

    this._chart.on(LEGEND_MOUSE_CLICK, this._onClickLegend.bind(this));

    this._chart.on(MOUSE_ENTER_HOTSPOT, this._onEnterChartHotSpot.bind(this));

    this._chart.on(LEGEND_MOUSE_ENTER_HOTSPOT, this._onEnterLegendHotSpot.bind(this));

    this._chart.on(MOUSE_LEAVE_HOTSPOT, this._onLeaveChartHotSpot.bind(this));

    this._chart.on(LEGEND_MOUSE_LEAVE_HOTSPOT, this._onLeaveLegendHotSpot.bind(this));

    this._chart.on(SELECTION_CHANGED, this._onSelectionChange.bind(this));

    this._chart.on(SORT, this._onSort.bind(this));

    this._chart.on(ERROR, this._onError.bind(this));

    this._chart.on("perfReady", this._onPerfReady.bind(this));

    if (this._isAutoResize()) {
      this._resizeSensor = new ResizeSensor(ReactDOM.findDOMNode(this), this._onResize);

      this._onResize();
    }

    this._renderChart();

    if (this.props.setChartInstance) {
      this.props.setChartInstance(this._chart);
    }
  };

  WaveChart.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this._resizeSensor) {
      this._resizeSensor.detach();
    }

    if (this._chart) {
      this._chart.remove();
    }
  };

  WaveChart.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this._maybeResize(this.getSize());

    this._maybeRender(prevProps);
  };

  WaveChart.prototype.getSize = function getSize() {
    if (this.props.width != null && this.props.height != null) {
      return [this.props.width, this.props.height];
    }
  };

  WaveChart.prototype.getChart = function getChart() {
    this._chart;
  };

  WaveChart.prototype._isAutoResize = function _isAutoResize() {
    // use the autoResize prop if it's specified, otherwise auto resize if no size is provided
    if (this.props.autoResize != null) {
      return this.props.autoResize;
    } else {
      return this.getSize() == null;
    }
  };

  WaveChart.prototype._onResize = function _onResize() {
    var ref = ReactDOM.findDOMNode(this);
    var clientWidth = ref.clientWidth;
    var clientHeight = ref.clientHeight;

    this._maybeResize([clientWidth, clientHeight]);
  };

  WaveChart.prototype._maybeResize = function _maybeResize(newSize) {
    if (this._chart != null && newSize && !_.isEqual(newSize, this._currentSize)) {
      this._currentSize = newSize;

      (ref = this._chart).resize.apply(ref, newSize);
    }

    var ref;
  };

  WaveChart.prototype._maybeRender = function _maybeRender(prevProps) {
    var noSize = {
      width: undefined,
      height: undefined
    };

    var prevPropsWithoutSize = _.extend({}, prevProps, noSize);

    var propsWithoutSize = _.extend({}, this.props, noSize);

    if (!_.isEqual(prevPropsWithoutSize, propsWithoutSize) && this._chart != null) {
      this._renderChart();
    }
  };

  WaveChart.prototype._onAfterRender = function _onAfterRender(params) {
    this.setState({
      isRendering: false
    });

    this._safeInvoke(this.props, "onAfterRender", params);
  };

  WaveChart.prototype._onClickChart = function _onClickChart(params) {
    this._safeInvoke(this.props, "onClickChart", params);
  };

  WaveChart.prototype._onClickLegend = function _onClickLegend(params) {
    this._safeInvoke(this.props, "onClickLegend", params);
  };

  WaveChart.prototype._onEnterChartHotSpot = function _onEnterChartHotSpot(params) {
    this._safeInvoke(this.props, "onEnterChartHotSpot", params);
  };

  WaveChart.prototype._onEnterLegendHotSpot = function _onEnterLegendHotSpot(params) {
    this._safeInvoke(this.props, "onEnterLegendHotSpot", params);
  };

  WaveChart.prototype._onLeaveChartHotSpot = function _onLeaveChartHotSpot(params) {
    this._safeInvoke(this.props, "onLeaveChartHotSpot", params);
  };

  WaveChart.prototype._onLeaveLegendHotSpot = function _onLeaveLegendHotSpot(params) {
    this._safeInvoke(this.props, "onLeaveLegendHotSpot", params);
  };

  WaveChart.prototype._onSelectionChange = function _onSelectionChange(params) {
    this._safeInvoke(this.props, "onSelectionChange", params);
  };

  WaveChart.prototype._onSort = function _onSort(params) {
    this._safeInvoke(this.props, "onSort", params);
  };

  WaveChart.prototype._onPerfReady = function _onPerfReady(params) {
    this._safeInvoke(this.props, "onPerfReady", params);
  };

  WaveChart.prototype._onError = function _onError(params) {
    this._safeInvoke(this.props, "onError", params);
  };

  WaveChart.prototype._safeInvoke = function _safeInvoke(target, funcName) {
    var args = [],
        len = arguments.length - 2;

    while (len-- > 0) {
      args[len] = arguments[len + 2];
    }

    target[funcName] ? target[funcName].apply(target, args) : undefined;
  };

  WaveChart.prototype._renderChart = function _renderChart() {
    var ref = this.props;
    var chartModule = ref.chartModule;
    var config = ref.config;
    var rows = ref.rows;
    var rowsMetadata = ref.rowsMetadata;
    var selection = ref.selection;
    var annotations = ref.annotations;
    var duration = ref.duration;
    var force = ref.force;

    if (!config) {
      return;
    }

    return this._chart.render(chartModule, config, rows, rowsMetadata, {
      selection: selection,
      annotations: annotations,
      duration: duration
    }, force);
  };

  WaveChart.prototype.render = function render() {
    var this$1 = this;
    var obj;
    var spinner;

    if (this.state.isRendering && this.props.spinner) {
      spinner = this.props.spinner;
    }

    var className = classNames("wave-chart", styles.waveChart, (obj = {}, obj[styles.loading] = !!spinner, obj), this.props.className);
    var style = {};

    if (this.props.width != null) {
      style.width = this.props.width + "px";
    }

    if (this.props.height != null) {
      style.height = this.props.height + "px";
    }

    return React.createElement('div', {
      className: className,
      style: style,
      'data-chart-name': this._chartName
    }, React.createElement('div', {
      ref: function ref(_ref) {
        return this$1._chartRef = _ref;
      }
    }), spinner);
  };

  return WaveChart;
}(React.Component);

WaveChart$1.propTypes = propTypes;
module.exports = WaveChart$1;